module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "katalog-tiket"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Content")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Content Video Gratis")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Video Gratis")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success btn-xs m-r-5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createContentVideo()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Tambah Video\n              ")])]), _vm._v(" "), _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("List Content Video")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('app-datatable', {
    attrs: {
      "items": _vm.VideoList,
      "has-action": true,
      "has-custom-pagination": true,
      "has-custom-search": true,
      "has-publish": true,
      "custom-pagination-current-page": _vm.pagination.currentPage,
      "custom-pagination-per-page": 10,
      "custom-pagination-total-pages": _vm.pagination.totalPages,
      "custom-pagination-sort-mode": _vm.pagination.sortMode,
      "headers": _vm.headers
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "dblClicked": function($event) {
        return _vm.updateVideo()
      },
      "deleted": function($event) {
        return _vm.deleteVideo($event)
      },
      "changePage": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {currentPage: $event})
      },
      "changeSortMode": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {sortMode: $event})
      },
      "doSearch": function($event) {
        _vm.search = {
          query: $event.value,
          by: _vm.headersKey[$event.key]
        }
      }
    }
  })], 1)])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71a726c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home_setting/free_video/FreeVideo.vue
// module id = 1365
// module chunks = 0